import { eventBus } from '@/main'

const DEFAULT_MESSAGE = 'Você tem alterações não salvas. Deseja continuar sem salvar?'

function unsavedChangesConfirm(message = DEFAULT_MESSAGE) {
	return new Promise((resolve) => {
		eventBus.$emit('open-unsaved-dialog', { message, resolve })
	})
}

export default {
	install(Vue) {
		if (Vue.prototype.$unsavedChangesConfirm) return
		Vue.prototype.$unsavedChangesConfirm = unsavedChangesConfirm
	},
}
